import { render, staticRenderFns } from "./FooterMenusTools.vue?vue&type=template&id=4ee9b12a"
import script from "./FooterMenusTools.vue?vue&type=script&lang=js"
export * from "./FooterMenusTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports